import { Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
// import DFLogo from "../../static/img/df-logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Login() {
  function setWithExpiry(key, value, ttl) {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  const navigate = useNavigate();

  const [loginPrompt, setLoginPrompt] = useState("Login");
  const [login, setLogin] = useState({
    email: "",
    password: "",
    errors: {},
  });
  const [loginError, setLoginError] = useState("");
  const handleInput = (e) => {
    setLogin({
      ...login,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginPrompt(<CircularProgress color="inherit" size={30} />);

    const data = {
      email: login.email,
      password: login.password,
    };
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post("/api/login", data)
        .then((res) => {
          if (res.status === 200) {
            setWithExpiry(
              "auth_token",
              "Bearer " + res.data.access_token,
              432000000
            );

            setWithExpiry("auth_user_email", res.data.user.email, 432000000);
            setWithExpiry("auth_user_name", res.data.user.name, 432000000);
            navigate("/dashboard/main");
          }
        })
        .catch((error) => {
          if (error.response.data.errors) {
            setLogin({ ...login, errors: error.response.data.errors });
            setLoginError("");
          } else {
            setLogin({ ...login, errors: {} });
            setLoginError(error.response.data[0].message);
          }
          setLoginPrompt("Login");
        });
    });
  };

  return (
    <div
      className="flex h-screen justify-center items-center"
      style={{ backgroundColor: "rgb(0, 172, 140)" }}
    >
      <form onSubmit={handleLogin} noValidate>
        <div className="flex flex-col justify-center pt-12 pb-12 px-5 border shadow-md bg-white space-y-4">
          {/* <h2 className="text-2xl font-semibold">Login</h2> */}
          <svg
            viewBox="0 0 650 223.8"
            // style={{ marginBottom: "40px", maxWidth: "200px", width: "100%" }}
            className="mx-10"
          >
            <g>
              <g>
                <path
                  d="M76.4,164.7c-2,8.2-4.7,15.6-8,22.1c2.9,1.2,5.7,2,8.2,2c26,0,37.3-31.8,37.3-57.8c0-32.4-14.3-43.5-28.5-43.5c-23,0-32,18.2-32,36.9c0,3.1,0.2,6.2,2.3,10v1.8l-17.2,2.3c-1.8-2.9-2.7-7.6-2.7-11.7c0-32.6,24.6-52.1,51.9-52.1c16.6,0,42.2,15,42.2,53.9c0,36.5-19.3,71.3-52.5,71.3c-5.9,0-10.5-1.8-14.6-3.7c-6.2,8.2-13.9,13.1-21.9,13.1c-9,0-15.8-4.7-15.8-12.9c0-9.2,7.2-18,21.3-18c2.9,0,6.4,1.2,10.2,2.7c1.4-4.1,2.5-8.8,3.9-14.1l14.4-62.5l16-2.1L76.4,164.7z M38.9,194.3c0,2.7,2,4.7,4.9,4.7c3.1,0,6.1-2.9,8.8-8.6c-2.5-1.4-5.3-2.1-7.8-2.1C41.4,188.3,38.9,190.8,38.9,194.3z M123,183.2l273.9-37.1l-2.5,10.7l-273.9,37.1L123,183.2z M183.3,147.9l-2.9,12.3c-2.5,2.1-9.8,7-21.5,7c-9.6,0-20.9-7.6-20.9-25.6c0-25.4,15.2-43.5,33-43.5c10,0,18.9,5.9,18.9,18.2c-1.4,16.8-14.4,26.9-36.3,28.7c0.8,6.8,4.5,10.3,11.7,10.3c8.2,0,14.1-4.5,17-7.4H183.3z M168.9,109.4c-7.2,0-13.7,10.7-15.2,26.2c13.3-1.6,20.7-8,20.7-19.3C174.4,112.1,172,109.4,168.9,109.4z M189.6,162.3L205.2,95l4.7-0.6l5.5,7.8c4.9-7.8,11.3-12.7,19.9-12.7c10.5,0,14.6,8.6,14.6,17.2c0,7.2-6.6,28.7-6.6,33.8c0,2.5,1.2,3.5,3.1,3.5l4.5-0.6l-1.8,7.4c-2.9,3.3-8.8,6.2-14.1,6.2c-5.3,0-9-3.5-9-9.8c0-4.7,8.2-34.8,8.2-38.9c0-4.1-1.4-6.8-4.3-6.8c-6.8,0-11.9,9.4-16.6,25.6l-7.4,33L189.6,162.3z M286.4,135.8l-2.3,10.2c-2.9,3.5-9.6,6.4-14.3,6.4c-7.4,0-11.7-5.7-11.7-12.1c0-3.5,5.9-28.5,9.6-43.3l-7.6,1l2.5-10.5l7.6-1l13.1-22.1l7.8-1.2l-4.9,21.1l12.7-1.8L296.6,93l-12.9,1.8c-6.2,27.5-9,39-9,41c0,2.3,1.6,3.9,4.3,3.9c2.3,0,4.7-1.4,6.6-3.9H286.4z M322.2,79.1c-2,8.6-12.1,50.8-12.1,52.9c0,2,0.8,2.9,2.5,2.9l5.3-0.8l-1.6,6.6c-2.5,3.9-8.6,7-13.9,7c-6.4,0-8.8-4.5-8.8-9.6c0-4.7,10-45.3,12.7-57L322.2,79.1z M306.7,69c0-6.8,7.8-9.6,14.3-9.6c3.3,0,7,1.6,7,4.7c0,6.4-8.6,9.2-14.4,9.2C310.6,73.3,306.7,71.7,306.7,69z M365.9,92.4c-3.3-3.3-9.6-7-14.3-7c-3.3,0-5.5,2.1-5.5,5.7c0,6.8,21.1,14.6,21.1,28.5c0,13.1-10,23-26.4,23c-6.1,0-14.1-4.7-17.2-8.8l2.5-11.1h1.4c4.9,5.5,11.1,8.4,15.4,8.4c5.3,0,8.6-3.5,8.6-8.2c0-8-21.5-15.4-21.5-29.1c0-11.1,8-20.1,22.5-20.1c7.4,0,13.3,3.7,16.6,7l-2.7,11.7H365.9z M402.8,119.9l-2.3,10.2c-2.9,3.5-9.6,6.4-14.3,6.4c-7.4,0-11.7-5.7-11.7-12.1c0-3.5,5.9-28.5,9.6-43.3l-7.6,1l2.5-10.5l7.6-1l13.1-22.1l7.8-1.2l-4.9,21.1l12.7-1.8L413,77.2l-12.9,1.8c-6.2,27.5-9,39.1-9,41c0,2.3,1.6,3.9,4.3,3.9c2.3,0,4.7-1.4,6.6-3.9H402.8z M406.1,155.3l26.6-115.2l-11.5,1.6l2.9-13.1l58.2-8l-2.9,13.1l-30.8,4.3l-8,35.5l20.1-2.9l-2.5,10.7L438,84l-15.8,69.1L406.1,155.3z M436.4,140.6L610,117.2l-2.5,10.9l-173.6,23.4L436.4,140.6z M494.8,55.9c-2,8.6-12.1,50.8-12.1,52.9c0,2,0.8,2.9,2.5,2.9l5.3-0.8l-1.6,6.6c-2.5,3.9-8.6,7-13.9,7c-6.4,0-8.8-4.5-8.8-9.6c0-4.7,10-45.3,12.7-57L494.8,55.9z M479.3,45.6c0-6.8,7.8-9.6,14.3-9.6c3.3,0,7,1.6,7,4.7c0,6.4-8.6,9.2-14.4,9.2C483.2,49.9,479.3,48.3,479.3,45.6z M495.2,121.1l15.6-67.4l4.7-0.6l5.5,7.8c4.9-7.8,11.3-12.7,19.9-12.7c10.5,0,14.6,8.6,14.6,17.2c0,6.4-6.6,30.7-6.6,33.8c0,2.5,1.2,3.5,3.1,3.5l4.5-0.6l-1.8,7.4c-2.9,3.3-8.8,6.2-14.1,6.2c-5.3,0-9-3.5-9-9.8c0-4.7,8.2-34.6,8.2-38.9c0-4.1-1.4-6.8-4.3-6.8c-6.4,0-11.9,9.4-16.6,25.6l-7.4,33L495.2,121.1z M609.8,16.1l15.2-2C616,53,607.2,87.9,607.2,91c0,2.1,0.8,3.5,3.3,3.5l4.9-0.6l-1.8,7.4c-3.1,2.7-8.2,6.2-14.1,6.2c-3.5,0-6.2-2.1-7.6-5.5c-3.5,5.1-8.6,8.6-15.6,8.6c-8.6,0-15.6-7-15.6-20.3c0-23.8,13.1-49.8,31.8-49.8c5.1,0,8.2,2.7,9.8,6.4L609.8,16.1z M576.8,87.3c0,7.6,2.5,11.1,5.5,11.1c3.7,0,7.8-2.7,10.5-10.2c1.4-5.9,3.1-14.3,5.3-23.2c1-5.9,0.6-13.3-5.5-13.3C585,51.8,576.8,73.5,576.8,87.3z"
                  style={{ fill: "rgb(81, 168, 130" }}
                />
              </g>
            </g>
          </svg>
          <h3>Call Tagging Automation</h3>
          <TextField
            label="Email"
            id="email"
            type="email"
            variant="outlined"
            sx={{ width: 300 }}
            name="email"
            error={
              login.errors
                ? login.errors.email
                  ? true
                  : loginError
                  ? true
                  : false
                : false
            }
            helperText={login.errors ? login.errors.email : ""}
            onChange={handleInput}
          />
          <TextField
            label="Password"
            id="password"
            type="password"
            variant="outlined"
            sx={{ width: 300 }}
            name="password"
            error={
              login.errors
                ? login.errors.password
                  ? true
                  : loginError
                  ? true
                  : false
                : false
            }
            helperText={login.errors ? login.errors.password : ""}
            onChange={handleInput}
          />
          {loginError ? (
            <em className="text-sm text-red-500">{loginError}</em>
          ) : (
            ""
          )}
          <Button
            style={{ backgroundColor: "rgb(251, 0, 91)" }}
            color="secondary"
            variant="contained"
            size="large"
            type="submit"
          >
            {loginPrompt}
          </Button>
        </div>
      </form>
    </div>
  );
}
